<div class="table-wrapper">
  <div class="actions">
    <ct-lib-table-search-input
      [placeholder]="'jobboard.platform.profile.sections.skills.search-placeholder'"
      (search)="onSearch($event)"
    />
    <app-button htmlType="button" [iconStart]="icons.plus" (click)="openAddModal()">
      {{ 'jobboard.platform.profile.sections.skills.add' | transloco }}
    </app-button>
  </div>

  @if (skills().length === 0) {
    <ct-lib-empty-placeholder
      [icon]="icons.empty"
      [title]="'jobboard.platform.profile.sections.skills.empty' | transloco"
      text=""
    />
  } @else if (visibleSkills().length === 0) {
    <ct-lib-empty-placeholder
      [icon]="icons.empty"
      [title]="'jobboard.platform.profile.sections.skills.search-empty' | transloco"
      text=""
    />
  } @else {
    <p-table
      [value]="visibleSkills()"
      dataKey="name"
      [rowTrackBy]="trackBySkill"
      sortField="name"
      [sortOrder]="1"
      [scrollable]="true"
      scrollHeight="40rem"
    >
      <ng-template #header>
        <tr>
          <th pSortableColumn="name" class="name-col">
            {{ 'jobboard.platform.profile.sections.skills.table.name' | transloco }}
            <fa-icon class="sort" [icon]="icons.sort"></fa-icon>
            <fa-icon class="sortUp" [icon]="icons.sortUp"></fa-icon>
            <fa-icon class="sortDown" [icon]="icons.sortDown"></fa-icon>
          </th>
          <th pSortableColumn="level">
            {{ 'jobboard.platform.profile.sections.skills.table.level' | transloco }}
            <fa-icon class="sort" [icon]="icons.sort"></fa-icon>
            <fa-icon class="sortUp" [icon]="icons.sortUp"></fa-icon>
            <fa-icon class="sortDown" [icon]="icons.sortDown"></fa-icon>
          </th>
          <th class="actions">
            {{ 'jobboard.platform.profile.sections.skills.table.actions' | transloco }}
          </th>
        </tr>
      </ng-template>
      <ng-template #body let-skill>
        <tr>
          <td>
            <span class="skill-name">{{ skill.name }}</span>
          </td>
          <td>
            <ct-lib-skill-level-tag
              [levelLabel]="skillLevelLabel(skill.level)"
              [options]="skillLevelOptions"
              [selectedValue]="skill.level"
              [deletable]="false"
              (levelChange)="updateSkillLevel(skill.name, $event)"
            />
          </td>
          <td class="actions">
            <fa-icon
              [icon]="icons.trash"
              size="lg"
              class="red"
              [tooltip]="'jobboard.platform.profile.sections.skills.remove' | transloco"
              [attr.aria-label]="'jobboard.platform.profile.sections.skills.remove' | transloco"
              (click)="removeSkill(skill.name)"
            ></fa-icon>
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</div>

<ct-lib-modal
  #addModal
  [small]="true"
  [label]="'jobboard.platform.profile.sections.skills.modal.title' | transloco"
  [footer]="addFooter"
>
  <div class="add-skill-form">
    <div class="form-group form-floating">
      <ng-select
        class="form-control"
        [formControl]="newSkillName"
        [items]="availableSkillNames()"
        [addTag]="true"
        [addTagText]="'jobboard.platform.profile.sections.skills.add-item' | transloco"
        appendTo="body"
        [placeholder]="'jobboard.platform.profile.sections.skills.name' | transloco"
        id="profileSkillName"
      ></ng-select>
      <label for="profileSkillName">{{
        'jobboard.platform.profile.sections.skills.name' | transloco
      }}</label>
    </div>
    <div class="form-group form-floating">
      <ng-select
        class="form-control"
        [formControl]="newSkillLevel"
        [clearable]="false"
        [searchable]="false"
        appendTo="body"
        [placeholder]="'ct-library.constants.ng-select.placeholders.placeholder' | transloco"
        id="profileSkillLevel"
      >
        @for (option of skillLevelOptions; track option.value) {
          <ng-option [value]="option.value">{{ option.label | transloco }}</ng-option>
        }
      </ng-select>
      <label for="profileSkillLevel">{{
        'jobboard.platform.profile.sections.skills.level' | transloco
      }}</label>
    </div>
  </div>
</ct-lib-modal>

<ng-template #addFooter>
  <button type="button" class="ct-btn ct-btn-white-grey" (click)="closeAddModal()">
    {{ 'jobboard.platform.profile.sections.skills.modal.cancel' | transloco }}
  </button>
  <button
    type="button"
    class="ct-btn ct-btn-primary"
    [disabled]="!(newSkillName.value ?? '').toString().trim()"
    (click)="submitAddSkill()"
  >
    {{ 'jobboard.platform.profile.sections.skills.modal.submit' | transloco }}
  </button>
</ng-template>
